<template>
  <div v-if="isShow" class="bg_white pb48">
    <Mv />

    <div class="contens_wrap pl20 pr20">
      <p class="page_title ab">本規約をご確認の上「同意して利用する」<br class="">ボタンをタップしてお進みください</p>
      <div class="privacy_wrap">
        <h2 class="privacy_title ab">XXXXXXXXXXXXXXXX</h2>
        <p class="privacy_text ar">あああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああ</p>
        <p class="privacy_text ar">あああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああ</p>
      </div>
      <div class="privacy_check kodomo_wrap">
        <input class="kodomo_check" type="checkbox" id="checkbox01" name="checkbox01" v-model="isChecked">
        <label for="checkbox01" class="checkbox01 ab">利用規約に同意する</label>
      </div>
      <button class="terms_btn" @click="submit" :class="isChecked ? 'btn_blue' : 'btn_delete'" :disabled="!isChecked">次へ</button>
    </div>

  </div>
<div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import Check from '@/model/getToken'
import Mv from '@/components/fanClub/RegisterMv'

export default {
  components: {
    Mv
  },
  data() {
    return {
      isShow: true,
      isChecked: false,
    }
  },
  methods: {
    submit() {
      console.log('click');
      this.$router.push({ name: 'fanClubRegisterSelectPlan' });
    }
  },
  computed: {
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      let redirectUrl = this.$route.query.redirectUrl;
      if(redirectUrl) {
        this.$store.commit('setFanClubRedirectUrl', redirectUrl);
      }
    } else {
      // this.isShow = false;
    }



  }
}
</script>

<style lang="css" scoped>
.content_title {
  max-width: 160px;
}
.page_title {
  font-size: 16px;
  padding-left: 10px;
}
.contens_wrap {
  margin-top: 30px;
}
.privacy_wrap {
  background-color: #ececec;
  border-radius: 10px;
  margin-top: 28px;
  max-height: 230px;
  overflow-y: scroll;
  padding: 24px 8px;
}
.privacy_title {
  font-size: 15px;
}
.privacy_text {
  font-size: 12px;
  line-height: 1.5;
  margin-top: 15px;
}
.privacy_check {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.terms_btn {
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/register/Terms.vue